export default __webpack_public_path__ + "static/media/parrot-pass-glowing.670a6c41.png";